module.exports = __webpack_public_path__ + "img/upload-vehicle_back.783af0f1.png";